var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#113F57",
    width: "800px",
    height: "800px",
    viewBox: "-6 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "copyright") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76 21.68c-1.52 0-2.96-0.6-4.040-1.68-2.24-2.24-2.24-5.84 0-8.040 1.080-1.080 2.52-1.68 4.040-1.68v0c1.52 0 2.96 0.6 4.040 1.68 0.32 0.32 0.32 0.84 0 1.2-0.32 0.32-0.84 0.32-1.2 0-0.76-0.76-1.76-1.16-2.84-1.16v0c-1.080 0-2.080 0.4-2.84 1.16-1.56 1.56-1.56 4.12 0 5.68 0.76 0.76 1.76 1.16 2.84 1.16s2.080-0.4 2.84-1.16c0.32-0.32 0.84-0.32 1.2 0 0.32 0.32 0.32 0.84 0 1.2-1.12 1.080-2.52 1.64-4.040 1.64zM9.76 25.76c-5.4 0-9.76-4.4-9.76-9.76s4.36-9.76 9.76-9.76c5.36 0 9.76 4.36 9.76 9.76s-4.4 9.76-9.76 9.76zM9.76 7.92c-4.44 0-8.080 3.6-8.080 8.080s3.6 8.080 8.080 8.080c4.44 0 8.080-3.6 8.080-8.080s-3.6-8.080-8.080-8.080z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/cc.a145f036e6b36ff261c36cede043f005.svg";
export { ForwardRef as ReactComponent };